$(function () {

    /**
     * header导航
     */
    $(".header-tab2").click(function () {
       $("html,body").animate({
           scrollTop:"821px"
       },500);
    });
    $(".header-tab3").click(function () {
        $("html,body").animate({
            scrollTop:"4893px"
        },500);
    });
    $(".header-tab4").click(function () {
        $("html,body").animate({
            scrollTop:"5832px"
        },500);
    });


    /**
     * 返回顶部
     */
    $(".return-top").click(function () {
        $("html,body").animate({
            scrollTop:"0px"
        },500);
    });

    $(document).scroll(function () {
        if (getScrollTop() > 821){
            $(".return-top").fadeIn()
        } else {
            $(".return-top").fadeOut()
        }
    });

    // scrollTop兼容性处理
    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }

    /**
     * 赛程切换
     */
    $(".lv1-plan1 li").click(function () {
       $(".lv1-war-audition").show().siblings(".lv1-war-eight").hide();
        $(".lv1, .lv1-box").removeClass("active");
    });
    $(".lv1-plan2 li").click(function () {
        $(".lv1-war-eight").show().siblings(".lv1-war-audition").hide();
        $(".lv1, .lv1-box").addClass("active");
    });

    /**
     * 赛事直播
     */
    $(".lv2-content div").hover(
        function () {
            var domThis = $(this);
            domThis.children("span").slideToggle("fast",function () {
                domThis.children("a").show();
            })
        },
        function () {
            var domThis = $(this);
            domThis.children("a").fadeOut("fast",function () {
                domThis.children("span").slideUp();
            })
        }
    );

    /**
     * 正赛奖励
     */
    $(".lv3-rank-tab li").click(function () {
        $(this).addClass("active").siblings().removeClass("active");
        $(".lv3-rank-content li").eq($(this).index()).show().siblings().hide();
    });

    /**
     * 登录
     */
    var auth = ycgame.auth;

    $(".lv4-phone a, .lv4-e-mail a").click(function (e) {
        if (! auth.member) {
            $.ycUserDialogOpen();
            e.stopImmediatePropagation();
        }
    });

    auth.bind( auth.EVENTS.LOGOUT, function () {
        location.reload();
    });

    auth.checkLogin();

    auth.bind( auth.EVENTS.LOGIN, function () {

        role();

        $(".lv4-phone a").click(function () {
            var id1 = 1,
                id2 = 1;
            accountInformation(id1, id2);
        });

        $(".close-binding").click(function () {
            $(".binding-phone").hide();
        });

        $(".identifying-code").click(function () {
            identifyingCode();
        });

        $("#send-code").click(function () {
            $(this).attr('disabled', true);
            var mobile = $("#phone").val(),
                imgCaptchaId = $(".identifying-code").attr("data-id"),
                imgCaptchaInput = $("#identifying-code").val();

            verificationCode(mobile,imgCaptchaId,imgCaptchaInput);
        });


        $("#submit-phone").click(function () {
            $(this).attr('disabled', true);
            var mobile = $("#phone").val(),
                smsCaptcha = $("#verification-code").val();

            binding(mobile,smsCaptcha);
        });

        /**
         * 邮件信息
         */
        $(".lv4-e-mail a").click(function () {
            var id1 = 0,
                id2 = 2;
            accountInformation(id1, id2);

        });
        $(".e-mail-submit input").click(function () {
            $(".warning").show();

        });
        $(".warning-submit").click(function () {
            $(".warning").hide();
            var addressee = $("#addressee").val(),
                contact = $("#contact").val(),
                addresses = $("#addresses").val();
            eMail(addressee,contact,addresses);
        });
        $(".warning-close").click(function () {
            $(".warning").hide();
        });
        $(".e-mail-close").click(function () {
            $("#addressee").val("");
            $("#contact").val("");
            $("#addresses").val("");
            $(".e-mail").hide();
        });


        $(".hint-window input").click(function () {
            $(".hint-window-text").html("");
            $(".hint-window").hide();
        })
    });

    // 初始化帐号信息
    function role() {
        $.ajax({
            type: "GET",
            url: "http://act-api.bos.ycgame.com/users/me",
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".login-username-id").html(data.username);
            $(".login").css("opacity",1);

        }).fail(function (xhr) {

        })
    }

    /**
     *帐号资格
     */
    function accountInformation(id1,id2) {
        $.ajax({
            type: "GET",
            url: "http://act-api.bos.ycgame.com/war/teams/vadalite-top/" + id1,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            if (id2 == 1){
                identifyingCode();
                $(".binding-phone").fadeIn();
            } else if (id2 == 2){
                $(".e-mail").fadeIn();
            }

        }).fail(function (xhr) {
            if (xhr.status == 403 && xhr.responseJSON.code == "forbid") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的账号尚未获取资格，无法绑定手机号！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您已提交过资料，请勿重复操作！")
                })
            }

        })
    }

    /**
     * 绑定手机
     * @param mobile
     * @param smsCaptcha
     */
    function binding(mobile,smsCaptcha) {
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/war/teams/bind-mobile/1",
            data:{"mobile":mobile,"sms_captcha":smsCaptcha},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $("#submit-phone").removeAttr('disabled');
            $(".binding-phone").hide();
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("恭喜您成功绑定手机号，祝您游戏愉快！")
            })


        }).fail(function (xhr) {
            $("#submit-phone").removeAttr('disabled');
            if (xhr.status == 403 && xhr.responseJSON.code == "forbid") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的账号尚未获取资格，无法绑定手机号！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的帐号已绑定过手机号，祝您游戏愉快！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "another") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的手机号已绑定过帐号，祝您游戏愉快！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            }
            if (xhr.status == 422 && xhr.responseJSON.validation_messages.mobile) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("手机号输入错误！")
                })
            }
            if (xhr.status == 422 && xhr.responseJSON.validation_messages.img_captcha) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("图形验证码输入错误！")
                })
            }

        })
    }

    /**
     * 图形验证码
     */
    function identifyingCode() {
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/img-captchas",
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {

            $(".identifying-code").attr("src",data.image_data).attr("data-id",data.captcha_id);

        }).fail(function (xhr) {


        })
    }

    /**
     * 手机验证
     * @param mobile
     * @param imgCaptchaId
     * @param imgCaptchaInput
     */
    function verificationCode(mobile,imgCaptchaId,imgCaptchaInput) {
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/sms-captchas",
            data:{"mobile":mobile,"type":"rss","img_captcha":{"id":imgCaptchaId,"input":imgCaptchaInput}},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $("#send-code").removeAttr('disabled')
            var second =  data.lock_time;
            setInterval(function () {

               if (second > 0){
                   $("#send-code").val("已发送(" + --second + "s)");
               } else {
                   $("#send-code").val("发送短信验证码");
               }

            },1000);

        }).fail(function (xhr) {

            $("#send-code").removeAttr('disabled');
            if (xhr.status == 422 && xhr.responseJSON.validation_messages.mobile) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("手机号输入错误！")
                })
            }
            if (xhr.status == 422 && xhr.responseJSON.validation_messages.img_captcha) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("图形验证码输入错误！")
                })
            }
            if (xhr.status == 403 && xhr.responseJSON.detail == "一个手机号每天只能发送3次短信,您的手机号已超出限制,请次日在试.") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的手机号已超出当日短信上限,请次日在试！")
                })
            }

        })
    }

    /**
     * 绑定地址
     * @param name
     * @param phone
     * @param address
     */
    function eMail(name, phone, address) {
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/war/teams/bind-receiving-info/0",
            data:{"name":name,"phone":phone,"address":address},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".e-mail").hide();
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("您已成功提交资料，感谢您的支持！")
            })
        }).fail(function (xhr) {
            if (xhr.status == 403 && xhr.responseJSON.code == "forbid") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的账号尚未获取资格，无法绑定邮箱！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您的帐号已绑定过邮箱，祝您游戏愉快！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            }
            if (xhr.status == 422) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("手机号输入错误！")
                })
            }
        })
    }



});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0